import { THEME } from "../theming/theming";
export var EXTRA_SMALL_BREAK = "@media screen and (max-width: ".concat(THEME.breakpoints.small - 1, "px)");
export var SMALL_BREAK = "@media screen and (min-width: ".concat(THEME.breakpoints.small, "px)");
export var MEDUIM_BREAK = "@media screen and (min-width: ".concat(THEME.breakpoints.medium, "px)");
export var LARGE_BREAK = "@media screen and (min-width: ".concat(THEME.breakpoints.large, "px)");
